import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeTheme } from '@altios/theme/theme';
import { PortalApp } from './PortalApp';
import { PublicIntakeForm } from './components/PublicIntakeForm';
import './portal.css';
import './styles/portal-next.css';

initializeTheme();
const publicIntake = window.location.hostname === 'intake.altiosbuilders.com' || window.location.pathname === '/intake';
if (publicIntake) document.title = 'Start Your Project | Altios Builders';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {publicIntake ? <PublicIntakeForm /> : <PortalApp />}
  </StrictMode>
);
